import React, {useState} from 'react';
import styled from 'styled-components';
import {Subheading} from 'app/styles/heading';
import {SIZES, Line, Typography} from '@fupa/fupa-uikit';
import BestPlayerVoting from 'app/components/match/bestPlayer/BestPlayerVoting';
import {ProfileRowWrapper} from 'app/components/profile/ProfileStyles';
import {useLocation} from 'react-router';
import {useMarkOpenDialog} from 'app/hooks/useMarkOpenDialog';
import queryString from 'query-string';
import {DialogName} from 'app/common/DialogName';
import VotingButton from 'app/components/match/bestPlayer/VotingButton';
import VotingLeader from 'app/components/match/bestPlayer/VotingLeader';
import {FlexContainer} from 'app/styles/content';
import VotingStatus from 'app/components/match/bestPlayer/VotingStatus';

const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ButtonContainer = styled(FlexContainer)`
  justify-content: flex-end;
  margin-right: 1rem;
  margin-top: -0.5rem;
`;

const BorderLine = styled(Line)`
  margin-top: ${SIZES['8']};
`;

const PromoText = styled(Typography)`
  padding: 0 1rem;
  line-height: 1rem;
  &&& {
    opacity: ${props => (props.isLeague ? 1 : 0)};
  }
`;

const BestPlayer = ({match, lineupVoting, isFetching}) => {
  const {search} = useLocation();
  const [open, setOpen] = useState(() => {
    const searchParams = queryString.parse(search);
    return !!searchParams.dialog?.includes(DialogName.BestPlayerVoting);
  });

  useMarkOpenDialog(open, DialogName.BestPlayerVoting);

  const openDialog = () => {
    setOpen(true);
  };

  const closeDialog = () => {
    setOpen(false);
  };

  const isLeague = match?.competitionCategoryId === 1;
  return (
    <ProfileRowWrapper>
      <Header>
        <Subheading variant='subheading2'>Bester Spieler</Subheading>
      </Header>
      <PromoText isLeague={isLeague} variant='caption1'>
        Stimme für die besten Spieler, um ihnen in die Elf der Woche zu verhelfen!
      </PromoText>
      <div>
        <VotingLeader
          isFetching={isFetching}
          leader={lineupVoting?.bestPlayer}
          onClick={openDialog}
          homeTeamSlug={match.homeTeam?.slug}
          votingStatus={lineupVoting?.status}
        />
        <ButtonContainer>
          <VotingButton onClick={openDialog} votingStatus={lineupVoting?.status} isFetching={isFetching} />
        </ButtonContainer>
        <BestPlayerVoting
          active={lineupVoting?.status === VotingStatus.InProgress}
          handleClose={closeDialog}
          open={open}
        />
      </div>
      <BorderLine />
    </ProfileRowWrapper>
  );
};

export default BestPlayer;
